<template>
    <div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <vs-input size="large" class="w-full" label-placeholder="Cep" v-model="form.company.address.zip" name="cep" v-validate="'required'" @change="searchCepData"/>
                <span class="text-danger text-sm"  v-show="errors.has('cep')">{{ errors.first('cep') }}</span>
            </div>
            <div class="vx-col w-1/2">
                <vs-input size="large" class="w-full" label-placeholder="Bairro" v-model="form.company.address.neighborhood" name="bairro" v-validate="'required'"/>
                <span class="text-danger text-sm"  v-show="errors.has('bairro')">{{ errors.first('bairro') }}</span>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-2/3">
                <vs-input size="large" class="w-full" label-placeholder="Rua" v-model="form.company.address.street" name="rua" v-validate="'required'"/>
                <span class="text-danger text-sm"  v-show="errors.has('rua')">{{ errors.first('rua') }}</span>
            </div>
            <div class="vx-col w-1/3">
                <vs-input size="large" class="w-full" label-placeholder="Numero" v-model="form.company.address.number" name="numero" v-validate="'required'" ref="numero" />
                <span class="text-danger text-sm"  v-show="errors.has('numero')">{{ errors.first('numero') }}</span>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <vs-select size="large" class="w-full" placeholder="Estado" label="Estado" label-placeholder="Estado" autocomplete v-model="form.company.address.region" v-validate="'excluded:0'" name="region" :danger="errors.has('region')" @change="setCities">
                    <vs-select-item :key="index" v-for="(region, index) in getRegions()" :text="region.estado" :value="region.uf"></vs-select-item>
                </vs-select>
            </div>
            <div class="vx-col w-1/2">
                <vs-select size="large" class="w-full" placeholder="Cidade" label="Cidade" label-placeholder="Cidade" autocomplete v-model="form.company.address.city" :disabled="!form.company.address.region" v-validate="'excluded:0'" name="city" :danger="(form.company.address.region > 0 && errors.has('city'))" @change="setCityIbgeCode">
                    <vs-select-item :key="index" v-for="(city, index) in getCities()" :text="city.nome" :value="city.nome"></vs-select-item>
                </vs-select>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    props: {
        form:Object
    },

    data () {
        return {
            regions: [
                {id_estado:0, estado: 'Estado'}
            ],

            cities: [
                {id_cidade:0, nome: 'Cidade'}
            ]
        }
    },

    methods: {
        async setRegions () {
            const {data} = await this.$axios.get("company/consulta/regions");
            this.regions = data;
        },
        getRegions () {
            return this.regions;
        },

        async setCities () {
            const {data} = await this.$axios.get(`company/consulta/regions/${this.form.company.address.region}/cities`);
            this.cities = data;
            if (this.regions[0].id_estado != 0) {
                this.form.company.address.region_code = this.regions.filter(region => region.uf == this.form.company.address.region)[0].codigo_ibge;
            }
        },

        setCityIbgeCode () {
            if (this.cities[0].id_cidade != 0) {
                this.form.company.address.city_code = this.cities.filter(cidade => this.form.company.address.city == cidade.nome)[0].codigo_ibge;
            }
        },
        getCities () {
            return this.cities;
        },

        async validateForm () {
            return await this.$validator.validateAll().then(result => {
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        }
    },

    created () {
        this.setRegions();
        if (this.form.company.address.region) {
            this.setCities();
        }
        this.searchCepData = _.debounce(async (q) => {
            Axios.get(`https://viacep.com.br/ws/${q.target.value.replace(/\W/g, '')}/json/`).then(({data})=>{
                if (!('erro' in data)) {
                    this.form.company.address.city = data.localidade;
                    this.form.company.address.neighborhood = data.bairro;
                    this.form.company.address.region = data.uf;
                    this.form.company.address.street = data.logradouro;
                }
            }).catch((err)=>{
                console.log(err);
            })
        }, 300);
    }
}
</script>

<style>

</style>
